'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messageToJson = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _pick = require('transmute/pick');

var _pick2 = _interopRequireDefault(_pick);

var _merge = require('transmute/merge');

var _merge2 = _interopRequireDefault(_merge);

var _toJS = require('transmute/toJS');

var _toJS2 = _interopRequireDefault(_toJS);

var _messageTypes = require('../constants/messageTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEYS_TO_SERIALIZE = ['client', 'clientTs', 'id', 'metadata', 'senderId', 'senderType', 'timestamp', 'text', 'url', 'richText', 'messageId', 'type', 'previousMessageClientTs', 'threadId'];

var messageToJson = exports.messageToJson = function messageToJson(message) {
  return (0, _pipe2.default)(_toJS2.default, function (payload) {

    // Create a V1-V2 Hybrid message to maintain compatibility with older clients
    var hybridPayload = (0, _merge2.default)(payload.metadata, payload);
    hybridPayload.messageId = payload.metadata.welcomeMessageId;
    hybridPayload.type = payload.metadata[_messageTypes.MESSAGE_TYPE_ID];
    hybridPayload.from = null;
    hybridPayload.metadata.from = null;
    return hybridPayload;
  }, (0, _pick2.default)(KEYS_TO_SERIALIZE))(message);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/MessageToJson.js
// module id = 770
// module chunks = 2 3